import { Injectable } from "@angular/core";
import { Resolve } from "@angular/router";
import { ApiService } from "../services/api.service";
import { DataTransferService } from "../services/data.transfer.service";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";

@Injectable({
    providedIn: "root",
})
export class FeatureTagResolver implements Resolve<any> {
    constructor(
        private apiService: ApiService,
        private dataTransferService: DataTransferService
    ) { }

    resolve(): Observable<any> {

        const storeId = this.dataTransferService.getStoreId();
        if (!storeId) {
            console.error("No store ID found in storeData");
            return of(null);
        }

        const featureTags = JSON.parse(this.dataTransferService.getFeatureTags());
        if (featureTags === null || featureTags.length === 0) {
            return this.fetchFeatureTags(storeId);
        } else {
            return of(featureTags);
        }
    }

    private fetchFeatureTags(storeId: string): Observable<any> {
        return this.apiService
            .getFeatureTags({ app_name: "sf", store_id: storeId })
            .pipe(
                map((response: any) => {
                    this.dataTransferService.setFeatureTags(JSON.stringify(response["data"]["featureTags"]))

                    return response["data"]["featureTags"];
                }),
                catchError((error) => {
                    console.error("FeatureTagResolver fetching failed", error);
                    return of('error');
                })
            );
    }
}